<template>
    <modal
      :show-modal="showModal"
      @close-modal="closeModal"
      width="40"
    >
       <div>
        <h2 class=" text-primary-yellow text-center font-semibold text-xl">Leave Us a Feedback</h2>
        <p class="py-2 text-center">We are constantly striving to make a better product for you,
            your feedback is vital to this process.</p>
           <p class="flex justify-center py-4">
            <img src="@/assets/images/icons/messege_icon.svg"/>
           </p>

        <div class="flex items-center justify-between">
            <div class="col-12 col-sm-6 p-0">
                <label class="pb-1 block w-full">Name:</label>
                <input class="w-full p-2 bg-gray-100 rounded"/>
            </div>
            <div class="col-12 col-sm-6">
                <label class="pb-1 block w-full">Email:</label>
                <input class="w-full p-2 bg-gray-100 rounded"/>
            </div>
        </div>

        <div>
            <label class="pb-1 block w-full mt-3">Product:</label>
           <el-select class="w-full max-w-sm">
            <option>saled</option>
           </el-select>
        </div>

        <div>
            <textarea class="w-full bg-gray-100 rounded h-56 p-3" placeholder="Tell us more about your experience..."></textarea>
        </div>

        <div>
            <label class="text-semibold text-primary-yellow mt-6">Did any of these contribute to your experience?</label><br>
            <span><base-checkbox/>Buying from our store</span><br>
            <span><base-checkbox/>Customer service response</span><br>
            <span><base-checkbox/>Using our product</span><br>
            <span><base-checkbox/>Finding and solving a problem</span><br>
        </div>

       <hr/>
        <div class="flex justify-between py-3">
            <button @click="closeModal">Take me back</button>
            <span>
                <abbr>1/2</abbr>
                <button class="px-3 py-2 bg-primary-yellow rounded ml-3"
                @click="$emit('triggerThankyou')"
                >Next</button>
            </span>
        </div>
       </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: ["showModal"],
    data(){
      return {
        reference: ""
      }
    },
    methods: {
      closeModal() {
        this.$emit("close-modal");
      },
    },
  };
  </script>
  
  <style> 
  .plain-box{
    width: 100%;
    height: 400px;
    position: relative;
  }
  .click-box{
    width: 200px;
    left: calc(100% - 100px);
    top: calc(100% - 100px);
    text-align: center;
    height: 30px;
  }
  .entity-name {
    background: #dae8f6;
    padding: 0.5em;
    text-align: center;
  }
  </style>